import React, { useState, type ComponentType } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useLeftSidebarState } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/left-sidebar-controller/index.tsx';
import { IsFhsEnabledProviderNavx2731 } from '@atlassian/jira-navigation-apps-sidebar-nav4-fhs-rollout/src/ui/is-fhs-enabled-provider-navx-2731/index.tsx';
import { PageLayout, type PageLayoutProps } from '@atlassian/jira-navigation-system/src/index.tsx';

// Used when full height sidebar is enabled
const PageLayoutWithFHSChanges = ({ children, ...props }: PageLayoutProps) => {
	const { isCollapsed } = useLeftSidebarState();
	const [defaultSideNavCollapsed] = useState(isCollapsed);

	return (
		<IsFhsEnabledProviderNavx2731 value>
			<PageLayout
				{...props}
				defaultSideNavCollapsed={defaultSideNavCollapsed}
				isSideNavShortcutEnabled
			>
				{children}
			</PageLayout>
		</IsFhsEnabledProviderNavx2731>
	);
};

export const JiraPageLayout: ComponentType<PageLayoutProps> = componentWithCondition(
	() =>
		fg('navx-2731-convert-jira-fhs-rollout')
			? expVal('navx-full-height-sidebar-exp', 'isEnabled', false)
			: fg('navx-full-height-sidebar'),
	PageLayoutWithFHSChanges,
	PageLayout,
);
